import { data, Link, useLoaderData, type LoaderFunctionArgs, type MetaFunction } from 'react-router'
import { Button } from '#app/components/ui/button.tsx'
import { unsubscribeUserFromMarketingToken } from '#app/services/lifecycle-emails/server.ts'

export const meta: MetaFunction = () => {
	return [{ title: 'Preferencias de email | IusPro' }]
}

export async function loader({ request, url }: LoaderFunctionArgs) {
	const token = url.searchParams.get('token')

	if (!token) {
		return data({
			success: false,
			title: 'No pudimos procesar tu solicitud',
			description: 'El enlace de baja no es válido o está incompleto.',
		})
	}

	const user = await unsubscribeUserFromMarketingToken(token)
	if (!user) {
		return data({
			success: false,
			title: 'No encontramos ese enlace',
			description: 'Es posible que el enlace haya expirado o ya no sea válido.',
		})
	}

	return data({
		success: true,
		title: 'Preferencias actualizadas',
		description: `Ya no enviaremos emails de seguimiento a ${user.email}.`,
	})
}

export default function UnsubscribePage() {
	const loaderData = useLoaderData<typeof loader>()

	return (
		<div className="flex min-h-[100dvh] items-center justify-center bg-neutral-50 px-4 py-10">
			<div className="w-full max-w-lg rounded-3xl border border-neutral-200 bg-white p-8 shadow-sm">
				<div className="space-y-3">
					<h1 className="text-2xl font-semibold text-neutral-900">{loaderData.title}</h1>
					<p className="text-sm leading-6 text-neutral-600">{loaderData.description}</p>
				</div>
				<div className="mt-6 flex flex-wrap gap-3">
					<Button asChild>
						<Link to="/">Ir a IusPro</Link>
					</Button>
					<Button asChild variant="outline">
						<a href="mailto:soporte@iuspro.com">Contactar soporte</a>
					</Button>
				</div>
			</div>
		</div>
	)
}
